'use client'

import { useProductListProvider } from 'product-list/context/ProductListProvider/useProductListProvider'
import { useVirtualPages } from 'product-list/hooks/useVirtualPages'
import { type ReactNode, useRef } from 'react'
import { cx } from 'utils/cx'

import styles from './Pagination.module.scss'

export function Pagination({
	children,
	total,
	perPage,
}: {
	children?: (count: number) => ReactNode
	total: number
	perPage: number
}) {
	const nextRef = useRef<HTMLDivElement>(null)

	const { count } = useProductListProvider()
	useVirtualPages(total, nextRef, perPage)

	return (
		<>
			{children?.(count)}
			<div className={styles.moreResultsContainer}>
				<div
					role='presentation'
					className={cx(styles.moreResults)}
					ref={nextRef}
				/>
			</div>
		</>
	)
}
